module.exports = __webpack_public_path__ + "static/python-logo-c290a443b3f240732252a813d4a6cf65.png";